
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars",
      function () {
        return require("private-next-pages/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/using-spotify-in-your-cafe-or-coffee-shop-could-cost-you-thousands-of-dollars"])
      });
    }
  